import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "tb-button-group !border-l-0" }

import { Editor } from '@tiptap/core';
import SectionItem from '@/components/editor/toolbar/SectionItem.vue';
import useTranslate from '@/utilities/composables/useTranslate';
import type { MenuItemFn, MenuItem, MenuItemOptions } from '@/components/editor/toolbar/menu-item';
import { computed, getCurrentInstance, provide, readonly, ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'MenuSection',
  props: {
    editor: {},
    commands: { type: Function },
    options: {}
  },
  setup(__props: any) {

const props = __props;

const { translate } = useTranslate();

const _this = getCurrentInstance();

/**
 * When this value is set to anything other than null,
 * these commands will populate the menu.
 */
const commandOverrides = ref<MenuItemFn | null>(null);

/**
 * Calling this changes the individual menu section contents.
 * Useful for creating "sub-menus" within the same toolbar.
 * @param com The menu item function, which returns the
 * required collection.
 */
function overrideCommands(com: MenuItemFn) {
  commandOverrides.value = com;
}

/**
 * Revert the menu section to its initial state, which
 * is using the props given to the MenuSection.
 */
function revertCommandOverrides() {
  commandOverrides.value = null;
}

provide('sectionCommandOverride', {
  commandOverrides: readonly(commandOverrides),
  overrideCommands,
  revertCommandOverrides,
});

const commandSource = computed(() => commandOverrides.value ?? props.commands);

const commands = computed(() =>
  commandSource
    .value({
      editor: props.editor,
      translate,
      store: _this?.proxy.$store!,
      appendTo: props?.options?.aiPopupAppendTo,
    })
    .filter((command: MenuItem) => {
      if (!command.hidden) return true;
      return command.hidden();
    })
);

provide('editor', props.editor);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(commands.value, ({
        effect,
        icon,
        tooltip,
        tooltipMeta,
        disabled,
        active,
        customProps,
        customButton,
        label,
        key,
      }) => {
      return (_openBlock(), _createBlock(SectionItem, _mergeProps({ ref_for: true }, customProps, {
        key: key ?? icon,
        effect: effect,
        icon: icon,
        tooltip: tooltip,
        meta: tooltipMeta,
        label: label,
        active: !!active?.(),
        disabled: !!disabled?.()
      }), {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_resolveDynamicComponent(customButton), _mergeProps({ ref_for: true }, {
          icon,
          effect,
          active: !!active?.(),
          disabled: !!disabled?.(),
          editor: _ctx.editor,
          ...customProps,
        }), null, 16))
        ]),
        _: 2
      }, 1040, ["effect", "icon", "tooltip", "meta", "label", "active", "disabled"]))
    }), 128))
  ]))
}
}

})